import IconWrapper from "@components/svg_icon_wrapper"

export default function ConversationCardWhatsappIcon() {
  return (
    <IconWrapper sx={{ width: 13, height: 13 }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        data-name="Layer 1"
        viewBox="0 0 512 512"
      >
        <defs>
          <linearGradient
            id="a"
            x1={1337.28}
            x2={1337.28}
            y1={518.24}
            y2={-2164.82}
            gradientTransform="matrix(.19 0 0 -.19 .81 98.89)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#61fd7d" />
            <stop offset={1} stopColor="#2bb826" />
          </linearGradient>
        </defs>
        <title>{"wa"}</title>
        <path
          d="M512 382.07c0 2.8-.09 8.88-.26 13.58-.41 11.49-1.32 26.32-2.7 33.07a109.76 109.76 0 0 1-9.27 27.71 98.45 98.45 0 0 1-43.43 43.39 110.21 110.21 0 0 1-27.87 9.28c-6.69 1.35-21.41 2.24-32.82 2.65-4.71.17-10.79.25-13.58.25h-252.1c-2.8 0-8.88-.09-13.58-.26-11.49-.41-26.32-1.32-33.07-2.69a110.37 110.37 0 0 1-27.72-9.28 98.5 98.5 0 0 1-43.42-43.47 110.21 110.21 0 0 1-9.28-27.87C1.55 421.74.66 407 .25 395.61.08 390.91 0 384.82 0 382V129.9c0-2.8.09-8.88.25-13.58C.71 104.86 1.62 90 3 83.28a110.37 110.37 0 0 1 9.27-27.72A98.59 98.59 0 0 1 55.7 12.18 110.21 110.21 0 0 1 83.57 2.9C90.26 1.55 105 .66 116.39.25 121.09.08 127.18 0 130 0h252.1c2.8 0 8.88.09 13.58.25C407.14.71 422 1.62 428.72 3a110.37 110.37 0 0 1 27.72 9.27 98.59 98.59 0 0 1 43.38 43.43 110.21 110.21 0 0 1 9.28 27.87c1.35 6.69 2.24 21.41 2.65 32.82.17 4.7.25 10.79.25 13.58Z"
          style={{
            fill: "url(#a)",
            fillRule: "evenodd"
          }}
        />
        <path
          d="M379.56 131.67a172.4 172.4 0 0 0-122.89-50.94c-95.67 0-173.62 77.91-173.62 173.69a173.47 173.47 0 0 0 23.2 86.82l-24.65 90 92.08-24.17a173.55 173.55 0 0 0 83 21.17h.07c95.73 0 173.69-77.91 173.69-173.69a172.73 172.73 0 0 0-50.91-122.85ZM256.72 399a144.17 144.17 0 0 1-73.52-20.14l-5.29-3.15L123.27 390l14.59-53.27-3.42-5.47a143.29 143.29 0 0 1-22.11-76.81C112.33 174.81 177.1 110 256.8 110a144.34 144.34 0 0 1 144.32 144.48c-.07 79.67-64.83 144.46-144.41 144.46Zm79.15-108.2c-4.32-2.2-25.68-12.67-29.65-14.12s-6.85-2.19-9.8 2.2-11.22 14.11-13.76 17-5.06 3.29-9.37 1.09-18.35-6.77-34.92-21.56c-12.88-11.5-21.61-25.74-24.15-30s-.29-6.71 1.92-8.83c2-1.93 4.32-5.06 6.51-7.6s2.88-4.32 4.32-7.26.74-5.42-.35-7.6-9.8-23.55-13.34-32.25c-3.49-8.51-7.12-7.32-9.79-7.47s-5.42-.13-8.29-.13a16 16 0 0 0-11.57 5.41c-4 4.32-15.2 14.86-15.2 36.22s15.54 42 17.72 44.91 30.61 46.76 74.14 65.54c10.34 4.44 18.42 7.11 24.72 9.18a60 60 0 0 0 27.32 1.71c8.35-1.23 25.68-10.49 29.31-20.62s3.63-18.83 2.55-20.62-3.91-3-8.29-5.22Z"
          style={{
            fill: "#fff",
            fillRule: "evenodd"
          }}
        />
      </svg>
    </IconWrapper>
  )
}
